<div class="container-fluid">
    <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <br>
            <div class="row">
                <div class="col-lg-4">
                    <img src="assets/img/auri.png" width="100%">
                </div>
                <div class="col-lg-4">
                    <h3>Registro de Clientes</h3>
                    <p>Grupo: {{grupo.nombre}}<br>
                        Carrera: {{grupo.carrera}}<br>
                        Escuela: {{grupo.escuela}}<br>
                    </p>
                </div>
            </div>
           
            <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario2.nombre"><br>
            <input type="text" class="form-control" placeholder="Apellido Paterno" [(ngModel)]="formulario2.apellidos"><br>
            <input type="text" class="form-control" placeholder="Apellido Materno" [(ngModel)]="formulario2.apellido_materno"><br>
            <input type="number" class="form-control" placeholder="Celular" [(ngModel)]="formulario2.celular" required><br>
            <input type="text" class="form-control" placeholder="Correo electrónico" [(ngModel)]="formulario2.email"><br>
            <input type="password" class="form-control" placeholder="Contraseña" [(ngModel)]="formulario2.password"><br>           
            <input type="password" class="form-control" placeholder="Repite tu contraseña" [(ngModel)]="formulario2.password2"><br>
            <input type="checkbox" [(ngModel)]="isChecked">Acepto los <a href="https://sandboxmb2.com/static/terminosycondicionesAuri.pdf" target="_blank">términos y condiciones</a> <br>
            <button class="btn btn-warning" (click)="agregarUsuarioGrupo(grupoid)">Agregar Usuario</button>
            <br><br>
        </div>
    </div>
</div>